
import React from "react";
import styles from "../../assets/style.module.css";

export interface TagBadgeProps {
    color?: string;
    className?: string;
    children: React.ReactNode;
}

function TagBadge({ children, color, className }: TagBadgeProps) {
    return (<span className={`${styles["tag-badge"]}${className ? ` ${className}` : ""}`} style={color ? { background: color, color: "#07050e" } : undefined}>
        {children}
    </span>);
}

export default TagBadge;
